// extracted by mini-css-extract-plugin
export default {"container":"svg-container_container__RAn3i","grabbing":"svg-container_grabbing__Pz7JH"};